// extracted by mini-css-extract-plugin
export default {"oktaGroups":"users-management_oktaGroups__X0XOO","oktaGroup":"users-management_oktaGroup__ftXsq","wide":"users-management_wide__8JB38"};